import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box text-center mb-3"
}
const _hoisted_2 = { class: "boxTitle" }
const _hoisted_3 = { class: "midTitle text-danger mt-3" }
const _hoisted_4 = { class: "row mt-3" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "midTitle" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "fs-14" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12 col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "midTitle mt-2" }
const _hoisted_16 = { class: "mt-2" }
const _hoisted_17 = { class: "midTitle mt-4" }
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = { class: "col-sm-12 col-md-6" }
const _hoisted_20 = { class: "mx-auto w-50" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "text-center mt-5" }
const _hoisted_25 = { class: "midTitle" }
const _hoisted_26 = { class: "mt-3" }
const _hoisted_27 = { class: "fs-14 mb-2" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "midTitle" }
const _hoisted_31 = { class: "row mt-3" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "box" }
const _hoisted_34 = { class: "boxTitle" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "box" }
const _hoisted_37 = { class: "boxTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_comments_container = _resolveComponent("comments-container")!

  return (_ctx.statoContratto)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: "Contratto di collaborazione",
            text: "Contratto di collaborazione"
          })
        ]),
        (_ctx.statoContratto == 'Respinto')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Il tuo contratto è stato respinto",
                  text: "Il tuo contratto è stato respinto"
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.rejectionReason), 1)
              ]),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendContratto && _ctx.sendContratto(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Clicca per ricominciare il processo",
                    text: "Clicca per ricominciare il processo"
                  })
                ])
              ])
            ], 64))
          : (_ctx.statoContratto == 'NonGenerato')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Ora puoi iniziare a collaborare con Antismoking Therapy!",
                    text: "Ora puoi iniziare a collaborare con Antismoking Therapy!"
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendContratto && _ctx.sendContratto(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Clicca per ricevere il contratto di collaborazione",
                      text: "Clicca per ricevere il contratto di collaborazione"
                    })
                  ])
                ])
              ], 64))
            : (_ctx.statoContratto == 'NonFirmato')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Abbiamo inviato all'indirizzo <b>{{email}}</b> il contratto e le istruzioni per proseguire",
                      text: "Abbiamo inviato all'indirizzo <b>{{email}}</b> il contratto e le istruzioni per proseguire",
                      object: { email: _ctx.user.contactData.email }
                    }, null, 8, ["object"])
                  ]),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Codice di conferma",
                            text: "Codice di conferma"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Inserisci l'OTP per firmare il contratto",
                            text: "Inserisci l'OTP per firmare il contratto"
                          })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otpText) = $event)),
                          class: "form-control-sm mt-2"
                        }, null, 512), [
                          [_vModelText, _ctx.otpText]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "I tuoi documenti",
                          text: "I tuoi documenti"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Carica una copia della tua carta d'identità e del tuo codice fiscale",
                          text: "Carica una copia della tua carta d'identità e del tuo codice fiscale"
                        })
                      ]),
                      _createVNode(_component_comments_container, {
                        class: "mt-2",
                        comments: _ctx.allegati,
                        onAdd: _ctx.addAllegato
                      }, null, 8, ["comments", "onAdd"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Se non hai ricevuto la mail, controlla di avere inserito l'indirizzo corretto nei tuoi dati di contatto.",
                          text: "Se non hai ricevuto la mail, controlla di avere inserito l'indirizzo corretto nei tuoi dati di contatto."
                        }),
                        _hoisted_21,
                        _createVNode(_component_localized_text, {
                          localizedKey: "Puoi richiedere un nuovo invio cliccando qui",
                          text: "Puoi richiedere un nuovo invio cliccando qui"
                        }),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendContratto && _ctx.sendContratto(...args))),
                            disabled: !_ctx.canSendOtp
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Invia nuovo contratto",
                              text: "Invia nuovo contratto"
                            }),
                            (_ctx.otpTimer)
                              ? (_openBlock(), _createBlock(_component_localized_text, {
                                  key: 0,
                                  localizedKey: "(attendi {{otpTimer}} secondi)",
                                  text: "(attendi {{otpTimer}} secondi)",
                                  object: { optTimer: _ctx.otpTimer }
                                }, null, 8, ["object"]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_23)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sign && _ctx.sign(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Firma e carica documenti",
                        text: "Firma e carica documenti"
                      })
                    ])
                  ])
                ], 64))
              : (_ctx.statoContratto == 'Approvato')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Il tuo contratto è stato approvato!",
                        text: "Il tuo contratto è stato approvato!"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Di seguito puoi scaricare i documenti del tuo contratto",
                          text: "Di seguito puoi scaricare i documenti del tuo contratto"
                        })
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signedDocuments, (x, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("a", {
                            href: x.publicUrl,
                            target: "_blank"
                          }, _toDisplayString(x.fileName), 9, _hoisted_28)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signedDocumentsUrls, (url, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("a", {
                            href: url,
                            target: "_blank"
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Visualizza contratto",
                              text: "Visualizza contratto"
                            }),
                            _createTextVNode(" " + _toDisplayString(i + 1), 1)
                          ], 8, _hoisted_29)
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Il tuo contratto è in attesa di approvazione",
                        text: "Il tuo contratto è in attesa di approvazione"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Documenti allegati",
                              text: "Documenti allegati"
                            })
                          ]),
                          _createVNode(_component_comments_container, {
                            comments: _ctx.allegati,
                            onAdd: _ctx.addAllegato
                          }, null, 8, ["comments", "onAdd"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Comunicazioni dall'amministrazione",
                              text: "Comunicazioni dall'amministrazione"
                            })
                          ]),
                          _createVNode(_component_comments_container, {
                            comments: _ctx.comments,
                            modify: false
                          }, null, 8, ["comments"])
                        ])
                      ])
                    ])
                  ], 64))
      ]))
    : _createCommentVNode("", true)
}